<template>
<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"
     x="0" y="0" viewBox="0 0 303.596 303.596" style="enable-background:new 0 0 512 512" xml:space="preserve"
     :width="size ? size : 512" :height="size ? size : 512"
     :class="[color]">
    <g>
        <path xmlns="http://www.w3.org/2000/svg" d="M273.193,62.099C245.08,25.376,202.332,4.314,155.911,4.314c-32.636,0-63.584,10.485-89.5,30.323  c-9.377,7.179-17.86,15.48-25.245,24.642l-6.585-37.299c-0.721-4.079-4.615-6.807-8.69-6.082L6.196,19.374  c-1.959,0.346-3.7,1.456-4.841,3.085c-1.141,1.63-1.587,3.645-1.241,5.604l15.646,88.629c0.643,3.638,3.807,6.198,7.377,6.198  c0.433,0,0.872-0.038,1.313-0.116l88.63-15.646c4.079-0.72,6.802-4.61,6.082-8.689l-3.477-19.695  c-0.346-1.959-1.455-3.7-3.085-4.841c-1.63-1.141-3.645-1.586-5.604-1.241l-36.933,6.52c5.195-6.14,11.075-11.741,17.624-16.754  c19.762-15.127,43.361-23.122,68.247-23.122c35.419,0,68.028,16.063,89.469,44.069c18.266,23.86,26.146,53.406,22.19,83.194  c-3.957,29.789-19.277,56.254-43.138,74.519c-19.818,15.171-43.38,23.19-68.139,23.19c-4.996,0-10.062-0.336-15.057-0.999  c-29.788-3.956-56.253-19.275-74.519-43.137c-11.118-14.523-18.59-31.659-21.609-49.556c-0.331-1.961-1.428-3.711-3.049-4.864  c-1.62-1.153-3.634-1.613-5.595-1.284l-19.721,3.327c-4.084,0.689-6.836,4.559-6.148,8.643c3.963,23.495,13.759,45.975,28.33,65.009  c23.948,31.284,58.647,51.37,97.702,56.557c6.534,0.868,13.165,1.308,19.708,1.308c32.486,0,63.39-10.514,89.369-30.402  c31.285-23.948,51.371-58.647,56.558-97.703C307.475,132.121,297.143,93.383,273.193,62.099z"></path>
    </g>
</svg>
</template>

<script>
export default {
    name: "IconReset",
    props: ['color', 'size'],
}
</script>

<style lang="scss" scoped>
path{fill:white}

.dark{
    path{
        fill:$dark;
    }
}

.danger{
    path{
        fill:$danger;
    }
}
</style>
